export default __webpack_public_path__ + "static/media/gallery_15.d43eb015.jpg";